import { render, staticRenderFns } from "./SuccessSubmitForm18.vue?vue&type=template&id=3cb904bc&scoped=true"
import script from "./SuccessSubmitForm18.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm18.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb904bc",
  null
  
)

export default component.exports